module.exports = __webpack_public_path__ + "img/bao-icon.8dd8aa89.svg";